<template>
  <content-dialog
    :visible.sync="modalVisible"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :small-title="$vuetify.breakpoint.xsOnly"
    max-width="400px"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template slot="dialogTitle">
      <div class="mb-2">
        Issue item to employee
      </div>
      <div class="body-1 grey--text text--darken-1">
        <strong>{{ inventoryItem.label }}</strong> in <flag
          :iso="inventoryItem.country.code"
          :squared="false"
        />
        {{ inventoryItem.base ? inventoryItem.base.name : inventoryItem.country.name }}
      </div>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text :class="{'pa-4': $vuetify.breakpoint.smAndUp }">
      <v-text-field
        v-model="amount"
        v-validate="'required|decimal'"
        name="amount"
        data-vv-as="amount"
        type="number"
        outlined
        label="Amount"
        hint="Amount that's being given to the employee"
        :error-messages="veeErrors.collect('amount')"
        :suffix="inventoryItem.unit"
        autocomplete="disable"
        persistent-hint
      />

      <assignee-modal-select
        v-model="staff"
        v-validate="'required'"
        data-vv-as="issue to"
        name="staff_id"
        :error-message="veeErrors.first('staff_id')"
        outlined
        clearable
        label="Issue to"
        type="staff"
        :dialog-visible.sync="staffSelectDialogVisible"
        @submit="staffSelectDialogVisible = false"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Submit
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
  import ContentDialog from '@/components/helpers/Dialog'
  import InventoryItem from '@/models/InventoryItem'
  import validationScrollMixin from '@/mixins/validationScrollMixin'
  import AssigneeModalSelect from '@/components/service/helpers/AssigneeModalSelect'

  export default {
    name: 'InventoryIssueDialog',
    components: {
      AssigneeModalSelect,
      ContentDialog
    },
    mixins: [
      validationScrollMixin
    ],
    props: {
      visible: Boolean,
      inventoryItem: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        amount: 1,
        staff: null,
        staffSelectDialogVisible: false,
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    methods: {
      async submit() {
        let validation = await this.$validator.validateAll()

        if (!validation) {
          this.showAlertAndScrollToFirstError()
          return
        }

        this.issueItem()
      },
      async issueItem() {
        this.submitting = true

        try {
          const result = await InventoryItem.api.issue(this.inventoryItem.id, this.amount, this.staff.id)

          const newInventoryItem = result.inventory_item

          this.$store.dispatch('alert', {
            'text': 'Successfully added stock.',
            'color': 'success'
          })

          this.$validator.reset()

          this.staff = null
          this.amount = 1

          this.$emit('inventoryItem:updated', newInventoryItem)

          this.modalVisible = false
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
